function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "full");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "UI",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "BP_dashboard_new_user",
  transform: "translate(-64.000000, -335.000000)",
  stroke: "#EFEFEF",
  strokeWidth: 8
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(24.000000, 278.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(14.000000, 61.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "progress_bar",
  transform: "translate(30.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M226.448028,175.006077 C235.105223,158.46279 240,139.649667 240,119.696203 C240,53.5898153 186.27417,0 120,0 C53.72583,0 0,53.5898153 0,119.696203 C0,139.651634 4.89574232,158.466499 13.5545319,175.01097",
  id: "full"
}))))));

var SvgProgressBarLine = function SvgProgressBarLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "248px",
    height: "181px",
    viewBox: "0 0 248 181",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProgressBarLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/progress_bar_line.ecd60e3e.svg";
export { ForwardRef as ReactComponent };